import { useQueryClient } from "@tanstack/react-query";

import { showToast } from "@/components/ui";
import { useAttributeReviewUsePastAnswersMutation } from "@/graphql/generated";

export function useApplyPastAnswers() {
  const queryClient = useQueryClient();
  const mutation = useAttributeReviewUsePastAnswersMutation({
    onSuccess: ({ attributeReviewUsePastAnswers: used }) => {
      void queryClient.invalidateQueries({
        queryKey: ["AttributeReviewFieldMappings"],
        refetchType: "all",
      });
      if (used) {
        showToast.success(
          "Used past answers",
          `${used} rows took this store's past answer.`,
        );
      } else {
        showToast.info("No past answers to use", "Every open row is new here.");
      }
    },
    onError: (err) => {
      showToast.error(
        "Could not use past answers",
        err instanceof Error ? err.message : "Try again.",
      );
    },
  });

  const applyPastAnswers = (sessionId: string) => {
    if (!mutation.isPending) mutation.mutate({ sessionId });
  };

  return { applyPastAnswers, isApplying: mutation.isPending };
}
